import React from 'react';
import { motion } from 'framer-motion';

const PhysicalAnimatronics = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl font-bold mb-6">Embracing Physical Animatronics</h2>
          <p className="text-lg leading-relaxed">
            While Universal initially leaned heavily on screens for attractions like Transformers and Spider-Man, it seems they have come to recognize the enduring appeal of physical animatronics. These tangible elements boost repeat attendance and enhance guest satisfaction by creating a more immersive and memorable experience. Universal's more recent attractions, such as Hagrid's Magical Creatures Motorbike Adventure, rely less on digital media and instead feature a remarkable use of animated figures and practical props.
          </p> 
          <p className="text-lg leading-relaxed">
            Disney has also explored the use of digital media, such as rear projections for character faces in attractions like Frozen Ever After at Epcot and Seven Dwarfs Mine Train at Magic Kingdom. However, Walt Disney Imagineering's latest iteration of Frozen in Hong Kong has delighted fans by replacing projections with physical, practical faces, showcasing their commitment to the craft of animatronics.
          </p> 
          <p className="text-lg leading-relaxed">
            The upcoming Universal's Epic Universe is anticipated to be a showcase of animatronic innovation, with attractions and themed lands based on Universal Classic Monsters, Super Mario, Donkey Kong, How to Train Your Dragon, and Harry Potter. Similarly, Disney's upcoming expansions, including attractions and lands inspired by Encanto, Cars, and the long-awaited Villains Land, are expected to feature a strong emphasis on animatronics. This renewed focus on physical effects and animated figures by both Universal and Disney highlights the industry's recognition of their timeless ability to captivate audiences.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <img
            src="/images/physical-animatronics.webp"
            alt="Modern physical animatronic figures in action"
            className="w-full rounded-lg"
          />
        </motion.div>
      </div>
    </section>
  );
}

export default PhysicalAnimatronics;